export const panelConstant = {
    OPEN_MODAL_PANEL: 'OPEN_MODAL_PANEL',
    CLOSE_MODAL_PANEL: 'CLOSE_MODAL_PANEL',
};

export default panelConstant;